import { getDateFnsLocale } from '@griply/utils';
import { setDefaultOptions } from 'date-fns';
import { useEffect } from 'react';
import { useI18nLocale } from 'shared/lib/react-i18next/use-i18n-locale';

export const useLocale = () => {
  const locale = useI18nLocale();

  useEffect(() => {
    setDefaultOptions({ locale: getDateFnsLocale(locale) });
  }, [locale]);
};
